import { useState, useContext } from 'react'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { AlignCenterItem } from '../../../components/common'
import { Text } from '../../../components/text'
import { HomeTermsTermsModal } from '../modals/HomeTermsModal'

import { FooterContainer, FooterDropdown } from './Footer.styled'

import { ReactComponent as DropIcon } from '../../../assets/ico/common/down_18.svg'

export function Footer() {
  const { openModal, closeModal } = useContext(ModalContext)

  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false)

  const openTermsModal = () => {
    const closeTermsModal = () => closeModal(MODALS_ID.TERMS)
    openModal({
      id: MODALS_ID.TERMS,
      Component: () => <HomeTermsTermsModal termsType="TERMS" close={closeTermsModal} />,
    })
  }

  const openPolicyModal = () => {
    const closePolicyModal = () => closeModal(MODALS_ID.POLICY)
    openModal({
      id: MODALS_ID.POLICY,
      Component: () => <HomeTermsTermsModal termsType="POLICY" close={closePolicyModal} />,
    })
  }

  const toggleDropdown = () => setIsDropdownOpen((prevState) => !prevState)

  return (
    <FooterContainer>
      <AlignCenterItem $gap={8}>
        <Text size={14} color="text_secondary" $cursor="pointer" onClick={openTermsModal}>
          이용약관
        </Text>
        <Text size={12} color="text_secondary">
          |
        </Text>
        <Text size={14} weight={500} $cursor="pointer" onClick={openPolicyModal}>
          개인정보처리방침
        </Text>
      </AlignCenterItem>
      <FooterDropdown isDropdownOpen={isDropdownOpen}>
        <AlignCenterItem $gap={3} onClick={toggleDropdown}>
          <Text size={14} weight={600}>
            (주)아티피오 사업자 정보
          </Text>
          <DropIcon />
        </AlignCenterItem>
        <Text size={14} lineHeight={22} color="text_secondary" block={true}>
          대표자: 김석환
          <br />
          주소: 서울시 영등포구 은행로 11, 6층 (여의도동, 일신빌딩)
          <br />
          사업자 등록번호: 267-87-02543
          <br />
          통신판매업 신고번호: 제2022-서울영등포-2230호
          <br />
          개인정보보호 책임자: 권민석
          {/* <br />
          고객센터: 1566-2966 (평일 10:00 ~ 17:00, 토/일/공휴일 휴무) */}
          <br />
          Email: artipio.official@gmail.com
        </Text>
      </FooterDropdown>
      <Text size={14} lineHeight={22} color="text_secondary" block={true}>
        ⓒ ARTIPIO Corp. All Rights Reserved.
      </Text>
    </FooterContainer>
  )
}
